import MapMessage from "./MapMessage";
export default MapMessage;